import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { User } from './user.model';
import { Partner } from './partner.model';
import { Prestation } from './prestation.model';

@CwtModel({ name: 'prestation-subscription', path: '/prestation-subscription' })
export class PrestatitonSubscription extends ApiData {
    user?: User;
    partner?: Partner;
    prestation?: Prestation;
    date?: Date;
    hasBeenNotified?: boolean;
    notificationDate?: Date;
}
